import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

// react-fast-marquee mesure l'ecran et ajoute des copies apres le montage : le defilement n'est donc
// rendu que cote navigateur. Le HTML pre-rendu ne contient que ce conteneur vide (data-marquee-slot),
// ce qui permet a React de reutiliser la page sans erreur d'hydratation.
export default function ClientMarquee({ children, className = "", ...props }) {
    const [mounted, setMounted] = useState(false);
    useEffect(() => setMounted(true), []);
    return (
        <div data-marquee-slot className={className}>
            {mounted ? <Marquee {...props}>{children}</Marquee> : null}
        </div>
    );
}
